import { FC, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import { useAppContext } from "@context/app";
import { useCartContext } from "@context/cart";
import { useLayoutContext } from "@context/layout";
import { IconButton } from "@shared/components/icon-button";
import { ICON_SIZE } from "@shared/components/icon-button/types";
import ArrowRightIcon from "@svg/new-design/arrow-right";
import { BANNER_OFFSET_HIDE } from "constants/layout-consts";
import InstructureIconHeader from "./InstructureIconHeader";

interface Props {
  instrutorName: string;
}

const InstructorHeader: FC<Props> = ({ instrutorName }) => {
  const router = useRouter();

  const { showFestivalBanner } = useAppContext();
  const { cart } = useCartContext();
  const { isAdmin, userData } = useLayoutContext();

  const isLoggedIn = userData?.is_login;

  const [showBanner, setShowBanner] = useState(showFestivalBanner);

  useEffect(() => {
    const handleScroll = () => {
      setShowBanner(window.scrollY < BANNER_OFFSET_HIDE);
    };

    handleScroll();

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const headerTop = useMemo(() => {
    if (isAdmin) {
      return showBanner && showFestivalBanner ? "106px" : "50px";
    }

    return showBanner && showFestivalBanner ? "56px" : "0px";
  }, [isAdmin, showBanner, showFestivalBanner]);

  const cartCount = cart?.length || 0;

  const cartHref = isLoggedIn ? "/checkout" : "/cart";

  const handleBack = () => {
    router.push("/");
  };

  return (
    <nav
      className="fds-l:hidden sticky inset-x-0 z-layout flex h-14 w-full items-center justify-between bg-fds-primary px-2 py-0.5 shadow-sm"
      style={{ top: headerTop }}
    >
      <div className="flex items-center gap-x-1.5">
        <IconButton
          hideTooltip
          size={ICON_SIZE.MEDIUM}
          icon={<ArrowRightIcon />}
          onClick={handleBack}
          aria-label="بازگشت"
        />

        <p className="title-lg text-fds-primary">{instrutorName}</p>
      </div>

      <IconButton
        hideTooltip
        size={ICON_SIZE.MEDIUM}
        aria-label=""
        icon={
          <InstructureIconHeader
            cartCount={cartCount}
            cartHref={cartHref}
            isLoggedIn={isLoggedIn}
          />
        }
      />
    </nav>
  );
};

export default InstructorHeader;
